"use Client";
import { useEffect, useState } from "react";
import * as ReactDOMClient from "react-dom/client";
import NewWindow from "react-new-window";
import { Button } from "../UI/Button";
import NotificationsCard from "./NotificationsCard";

function NotificationsTray() {
  const [notificationData, setNotificationData] = useState([
    {
      widget: "Action Summary",
      message: "New Trade: ARD-AU-2046",
      timestamp: "12:10",
      id: 1,
    },
    {
      widget: "Action Summary",
      message: "ANZ quoted on ARD-AU-20280",
      timestamp: "11:58",
      id: 2,
    },
  ]);
  const [badgeNumber, setBadgeNumber] = useState(notificationData.length);

  useEffect(() => {
    navigator.setAppBadge(badgeNumber);
  }, [badgeNumber]);

  const updateBadgeNumbers = () => {
    setBadgeNumber(badgeNumber + 1);
    navigator.setAppBadge(badgeNumber);
  };

  const clearBadgeNumbers = () => {
    setBadgeNumber(0);
    navigator.setAppBadge(badgeNumber);
    setNotificationData([]);
  };

  function generateWindow() {
    const container = document.createElement("div");
    const root = ReactDOMClient.createRoot(container);

    root.render(
      <NewWindow
        copyStyles={true}
        features={{ height: 470, width: 350 }}
        url={`/Popout?component=NotificationsTray`}
      ></NewWindow>,
    );
  }

  function deleteNotification(id: number) {
    const updatedData = notificationData.filter(
      (notification) => notification.id !== id,
    );
    setNotificationData(updatedData);
    setBadgeNumber(badgeNumber - 1);
  }

  return (
    <div
      className={`bg-cubeCustomColors.cubeBase[700] h-[470px] overflow-auto dark:bg-[#2d2d2d]`}
    >
      <div id="addWidget" className="flex w-full flex-col space-y-1 pb-1 ">
        * In Development *
        <div className="flex w-full flex-col gap-1">Actions</div>
        <Button
          variantToggle="selectionInactive"
          onClick={() => generateWindow()}
        >
          Pop out Tray
        </Button>
        <Button
          variantToggle="selectionInactive"
          onClick={() => {
            updateBadgeNumbers();
          }}
        >
          Test PWA Badge
        </Button>
        <Button
          variantToggle="selectionInactive"
          onClick={() => {
            clearBadgeNumbers();
          }}
        >
          Clear Notifications
        </Button>
        <Button
          variantToggle="selectionInactive"
          onClick={() => {
            Notification.requestPermission();
            // const notification = new Notification("Test Nofitification");
          }}
        >
          Test Browser Notification
        </Button>
        <div> Unread Notifications: {badgeNumber}</div>
      </div>
      <div className="max-h-[350px] space-y-2 ">
        {notificationData.map((x, index) => (
          <NotificationsCard
            widget={x.widget}
            message={x.message}
            timestamp={x.timestamp}
            key={index}
            id={x.id}
            deleteNotification={deleteNotification}
          />
        ))}
      </div>
    </div>
  );
}

export default NotificationsTray;
